import { useCallback, useMemo, useState } from 'react';

/**
 * @deprecated We've moved away from using useBoolean due to it's simplicity.
 * Use something like this instead: useState<boolean>(false)
 */
export const useBoolean = (initialState = false) => {
  const [isTrue, setIsTrue] = useState(initialState);

  const handleSetTrue = useCallback(() => {
    setIsTrue(true);
  },
  [setIsTrue]);

  const handleSetFalse = useCallback(() => {
    setIsTrue(false);
  },
  [setIsTrue]);

  const handleToggle = useCallback(() => {
    setIsTrue(x => !x);
  },
  [setIsTrue]);

  return useMemo(() => ({
    handleSetFalse,
    handleSetTrue,
    handleToggle,
    isTrue,
    setIsTrue,
  }),
  [
    handleSetFalse,
    handleSetTrue,
    handleToggle,
    isTrue,
    setIsTrue,
  ]);
};
